require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-baz-jeff-borough.json") })
        }
      }, "path---interview-baz-jeff-borough");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-baz-jeff-borough!./.cache/json/interview-baz-jeff-borough.json
// module id = 656
// module chunks = 231608221292675